/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Removeimageindicator from 'material/embeds/removeimageindicator/removeimageindicator';
import Background from 'material/embeds/content/shared/background/background_container';
import PartnerLogo from 'material/embeds/content/shared/logo/partner/partner_container';
import { EditableText } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/contenttype/emailcollection/emailcollection_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : STORY ~~~~~~~~~~ ========== */
class EmailCollection extends Component {
    constructor(props){
        super(props);
        this.body = props.body.value;
        this.headline = props.headline.value;
    }
    handleImageRemoval = () => {
        this.props.setCustomEmailCollectionImage(null);
        this.props.setCustomEmailCollectionPreviewImage(null);
    };
    render() {
        return(
            <div className={`uniquecontent emailcollection ${this.props.classes.emailcollection}`}>
                <div className={`structure header`}>
                    <div className={`structureinner`}>
                        <PartnerLogo />
                    </div>
                </div>
                <div className={`structure body`}>
                    <div className={`structureinner`}>
                        <div className={`editable editableheadline valid-${this.props.headline.valid}`}>
                            <EditableText
                                textColor={'inherit'}
                                outlineColor={'#fff'}
                                minHeight={'28px'}
                                defaultText={this.headline}
                                placeholder={'Type your headline here'}
                                onTextEdit={(text) => this.props.setUniqueEmailCollectionProperty('headline', text)}
                                isEditable={true}
                                validateText={()=>null}
                                preventEnterOnKeyDown={true}
                                characterLimit={40}
                                showCharacterCount={true} />
                        </div>
                        <div className={`editable editablebody valid-${this.props.body.valid}`}>
                            <EditableText
                                textColor={'inherit'}
                                outlineColor={'#fff'}
                                minHeight={'28px'}
                                defaultText={this.body}
                                placeholder={'Type your message text here'}
                                onTextEdit={(text) => this.props.setUniqueEmailCollectionProperty('body', text)}
                                validateText={()=>null}
                                isEditable={true}
                                preventEnterOnKeyDown={true}
                                characterLimit={80}
                                showCharacterCount={true} />
                        </div>
                        <div className={'useremail'}>User email</div>
                        <div className={'callouttext insticator'}>Agreeing to the COOL Media Privacy Policy</div>
                        <div className={'callouttext partner'}>Agreeing to the {!!this.props.publisherName.value ? this.props.publisherName.value : 'Sample'} Privacy Policy</div>
                    </div>
                </div>
                <Background
                    isSelected={this.props.isSelected}
                    backgroundImageURL={this.props.backgroundImageURL}
                    currentBackgroundImage={this.props.currentBackgroundImage}
                    previewBackgroundImageURL={this.props.previewEmailCollectionBackgroundImageURL}
                    backgroundColor={this.props.backgroundColor.value}
                    isEditable={true}/>
                {!!this.props.backgroundImageURL && <Removeimageindicator handleRemoval={this.handleImageRemoval}/>}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmailCollection);
